'use strict';

import { CoreRepository } from '../CoreRepository';
import { IndPharmacy } from '../../Entities/Ind/IndPharmacy';
import { IndPharmacyCollection } from '../../Collections/Ind/IndPharmacyCollection';

export class IndPharmacyRepository extends CoreRepository {
  public getIndPharmacies(indId: number, options: object = {}, criteria: object = null) {
    if (!options) {
      options = {};
    }

    if (criteria) {
      options['criteria'] = criteria;
    }

    return this.webAPI.getIndPharmacies(indId, options).then((response) => {
      const collection = new IndPharmacyCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new IndPharmacy();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }

  public createIndPharmacy(indId: number, payload: object = {}) {
    return this.webAPI.createIndPharmacy(indId, payload).then((response) => {
      const indPharmacy = new IndPharmacy();
      indPharmacy.hydrate(response);

      return indPharmacy;
    });
  }

  public removeIndPharmacy(indId: number, indPharmacyId: number) {
    return this.webAPI.removeIndPharmacy(indId, indPharmacyId).then((response) => {
      return response;
    });
  }

  public updateIndPharmacy(indId: number, indPharmacyId: number, payload: any[]) {
    return this.webAPI.updateIndPharmacy(indId, indPharmacyId, payload).then((response) => {
      return response;
    });
  }

  public moveIndPharmacy(individualId: number, individualPharmacyId: number, payload: any[]) {
    return this.webAPI
      .moveIndPharmacy(individualId, individualPharmacyId, payload)
      .then((response) => {
        return response;
      });
  }
}
